import { cn } from '#app/utils/misc'
import { WORDMARK_PATH, WORDMARK_VIEWBOX } from './wordmark-path'

/**
 * The TrueTenant wordmark as inline SVG, filled with `currentColor`, so one
 * component serves the header (ink), the footer (white) and the product
 * scenes (tiny). Pass `title={null}` when it is decorative.
 */
export function Wordmark({
	className,
	title = 'TrueTenant',
}: {
	className?: string
	title?: string | null
}) {
	return (
		<svg
			className={cn('block h-full w-auto', className)}
			viewBox={WORDMARK_VIEWBOX}
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
			role={title ? 'img' : undefined}
			aria-label={title ?? undefined}
			aria-hidden={title ? undefined : true}
			focusable="false"
		>
			<path d={WORDMARK_PATH} />
		</svg>
	)
}
